<div class="row align-items-center">
	<div class="col-auto" *ngIf="allowChild">
		<button nbButton ghost *ngIf="childOpen" (click)="toggleChild()">
			<nb-icon icon="arrow-ios-downward-outline"></nb-icon>
		</button>
		<button nbButton ghost *ngIf="!childOpen" (click)="toggleChild()">
			<nb-icon icon="arrow-ios-forward-outline"></nb-icon>
		</button>
	</div>
	<div class="col-sm-3 py-1" nbTooltip="{{ item.title }}">
		{{ item.title | truncate: 20 }}
	</div>
	<div class="col-sm py-1">
		<div class="row align-items-center">
			<div class="col-auto percentage-col">
				{{ item.durationPercentage || 0 }}%
			</div>
			<div class="col">
				<nb-progress-bar
					class="mb-1"
					[value]="item.durationPercentage"
					[status]="progressStatus(item.durationPercentage)"
					[displayValue]="true"
					size="tiny"
				>
				</nb-progress-bar>
			</div>
		</div>
	</div>
	<div class="col-sm-2 text-right py-1">
		{{ item.duration | durationFormat }}
	</div>
</div>
<div *ngIf="item?.childItems?.length && childOpen" class="child-items">
	<div class="row pt-2 pb-2 border-bottom font-weight-bold">
		<div class="col-sm-2">{{ 'TIMESHEET.TITLE' | translate }}</div>
		<div class="col-sm-8">{{ 'TIMESHEET.URL' | translate }}</div>
		<div class="col-sm-2 text-right">
			{{ 'TIMESHEET.TIME_SPENT' | translate }}
		</div>
	</div>
	<div
		class="row pt-2 pb-2 border-top"
		*ngFor="let childItem of item.childItems"
	>
		<div class="col-sm-2">
			{{ childItem.title }}
		</div>
		<div class="col-sm-8">
			{{ childItem.description }}
		</div>
		<div class="col-sm-2 text-right">
			{{ childItem.duration | durationFormat }}
		</div>
	</div>
</div>
